import React, { Fragment } from 'react'
import NavigationBarUser from './navigationbar/NavigationBarUser'
import { Outlet } from 'react-router-dom'

function LandingPage() {
  return (
    <Fragment>
      <div className='container-fluid g-0 p-0 overflow-hidden'>
        <div className='row'>
          <div className='empty-col'></div>
          <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
            <NavigationBarUser />
            <div className="width-outlate"><Outlet /></div>
          </div>
        </div>
      </div>
    </Fragment>
  )
}
export default LandingPage